export default "__VITE_ASSET__BIOkZC7u__"